import { cn } from "@/lib/cn";
import { Card } from "./Card";

/** 단일 스켈레톤 바 (펄스 애니메이션). */
export function Skeleton({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn("block animate-pulse rounded-[6px]", className)}
      style={{ background: "var(--surface-2)" }}
    />
  );
}

/** 리스트/카드 로딩용 스켈레톤 행 묶음. rows 개수만큼 카드 행을 렌더. */
export function SkeletonList({ rows = 4 }: { rows?: number }) {
  return (
    <Card className="flex flex-col gap-3 p-5" aria-busy>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3">
          <Skeleton className="h-9 w-9 rounded-full" />
          <div className="flex flex-1 flex-col gap-2">
            <Skeleton className="h-3.5 w-1/3" />
            <Skeleton className="h-3 w-1/2" />
          </div>
          <Skeleton className="h-5 w-16 rounded-full" />
        </div>
      ))}
    </Card>
  );
}

/** 테이블 로딩용 스켈레톤. cols/rows 만큼 셀 자리 렌더. */
export function SkeletonTable({ cols = 5, rows = 5 }: { cols?: number; rows?: number }) {
  return (
    <Card className="p-5" aria-busy>
      <Skeleton className="mb-3 h-4 w-24" />
      <div className="flex flex-col gap-3">
        {Array.from({ length: rows }).map((_, r) => (
          <div key={r} className="flex items-center gap-4">
            {Array.from({ length: cols }).map((_, c) => (
              <Skeleton key={c} className={cn("h-3.5", c === 0 ? "w-40" : "flex-1")} />
            ))}
          </div>
        ))}
      </div>
    </Card>
  );
}
